export function transformToLegacyFormat(affiliate, promoData = {}) {
  if (!affiliate?.promoCode) {
    return {
      affiliateId: null,
      btag: null,
      promo: null,
    };
  }

  const { promoCode, referrerUserId, utmSource, utmCampaign, utmMedium, utmContent, utmTerm, pid, clickid } = affiliate;

  const btag = JSON.stringify({
    aff_landing: promoData.aff_landing || '',
    aff_token: promoData.aff_token || '',
    promo_code: promoCode,
    referrer_user_id: referrerUserId || null,
    utm_source: utmSource || null,
    utm_campaign: utmCampaign || null,
    utm_medium: utmMedium || null,
    utm_content: utmContent || null,
    utm_term: utmTerm || null,
    clickid: clickid || null,
    pid: pid || null,
  });

  return {
    affiliateId: promoCode,
    btag,
    promo: promoData.promo || '',
  };
}
